import pubheader from './pubheader.vue'
export default pubheader